import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateNotifications } from '../../../redux/actions/uiActions';
import './Notifications.scss';
import closeIcon from '../../../images/notifications/x.png';

const Notifications = ({ notificationsList, position, updateNotifications }) => {
  const deleteToast = useCallback(
    (id) => {
      const updatedOfNotificationsList = notificationsList.filter((notification) => notification.id !== id);

      updateNotifications(updatedOfNotificationsList);
    },
    [notificationsList, updateNotifications],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (notificationsList.length > 0) {
        deleteToast(notificationsList[0].id);
      }
    }, notificationsList[0]?.deleteNotificationInMs);

    return () => {
      clearInterval(interval);
    };
  }, [notificationsList, deleteToast]);

  const defaultErrorObj = {
    title: 'Error',
    description: 'Failed To Fetch',
  };
  const validatedToasat = (toast) => (typeof toast.description === 'string' ? toast : defaultErrorObj);

  return (
    <>
      <div className={`notification-container ${position}`}>
        {notificationsList.map((toast, i) => (
          <div key={toast.id} className={`notification ${toast.type} toast ${position}`}>
            {/* <img
              src={closeIcon}
              onClick={() => deleteToast(toast.id)}
              alt="Close icon"
              className="notification-close-icon"
            /> */}
            {/* <div className="notification-image">
              <img src={toast.icon} alt="Notification icon" />
            </div> */}
            <div>
              <p className="notification-title">{validatedToasat(toast)?.title}</p>
              <p className="notification-message">{validatedToasat(toast)?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

Notifications.propTypes = {
  notificationsList: PropTypes.array.isRequired,
  position: PropTypes.string.isRequired,
  updateNotifications: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  notificationsList: state.ui.notificationsList,
});

export default connect(mapStateToProps, { updateNotifications })(Notifications);
